import React from 'react'
import Typography from '@material-ui/core/Typography'
import { Grid } from '@material-ui/core'
import { ResearchDetailViewType, ResearchDetailCtrlType } from './researchDetailType'
import useResearchDetail from './useResearchDetail'
import useTranslate from '../../../../i18n/useTranslate'
import MyAccordion from '../../../../control/accordion/accordion'

const ResearchDetailView: React.FC<ResearchDetailViewType> = ({ ...props }) => {
    const { initialData, hideAccordion = false } = props
    const translate = useTranslate()

    const renderElement = () => (
        <Grid container spacing={4}>
            <Grid container item>
                <Grid item xs={12} md={12} lg={3}>
                    <Typography variant={'body2'}>{translate.get('LABEL.IS_PHASE')} : </Typography>
                </Grid>
                <Grid item xs={12} md={12} lg={9}>
                    <Typography variant={'body2'}>
                        {initialData?.requestPhase ? translate.get('LABEL.YES') : translate.get('LABEL.NO')}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container item>
                <Grid item xs={12} md={12} lg={3}>
                    <Typography variant={'body2'}>{translate.get('LABEL.PHASE')} : </Typography>
                </Grid>
                <Grid item xs={12} md={12} lg={9}>
                    <Typography variant={'body2'}>{initialData?.requestPhase || '-'}</Typography>
                </Grid>
            </Grid>
            <Grid container item>
                <Grid item xs={12} md={12} lg={3}>
                    <Typography variant={'body2'}>{translate.get('LABEL.LABEL_05')} : </Typography>
                </Grid>
                <Grid item xs={12} md={12} lg={9}>
                    <Typography variant={'body2'}>
                        {initialData?.requestPhase
                            ? initialData?.isTools
                                ? translate.get('LABEL.YES')
                                : translate.get('LABEL.NO')
                            : '-'}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container item>
                <Grid item xs={12} md={12} lg={3}>
                    <Typography variant={'body2'}>{translate.get('LABEL.FACULTY')} : </Typography>
                </Grid>
                <Grid item xs={12} md={12} lg={9}>
                    <Typography variant={'body2'}>
                        {translate.languageStore.currentLanguage === translate.languageKey.th
                            ? initialData?.facultyInfo?.nameTH
                            : initialData?.facultyInfo?.nameEN}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container item>
                <Grid item xs={12} md={12} lg={3}>
                    <Typography variant={'body2'}>{translate.get('LABEL.IRB')} : </Typography>
                </Grid>
                <Grid item xs={12} md={12} lg={9}>
                    <Typography variant={'body2'}>{`REC ${initialData?.irb}`}</Typography>
                </Grid>
            </Grid>
            <Grid container item>
                <Grid item xs={12} md={12} lg={3}>
                    <Typography variant={'body2'}>
                        {`${translate.get('LABEL.PROJECT_NAME')}​ (${translate.get('LABEL.THAI')}​)`} :{' '}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={12} lg={9}>
                    <Typography variant={'body2'}>{initialData?.projectName_th}</Typography>
                </Grid>
            </Grid>
            <Grid container item>
                <Grid item xs={12} md={12} lg={3}>
                    <Typography variant={'body2'}>
                        {`${translate.get('LABEL.PROJECT_NAME')}​ (${translate.get('LABEL.ENG')}​)`} :{' '}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={12} lg={9}>
                    <Typography variant={'body2'}>{initialData?.projectName_en}</Typography>
                </Grid>
            </Grid>

            <Grid container item>
                <Grid item xs={12} md={12} lg={3}>
                    <Typography variant={'body2'}>
                        {`${translate.get('LABEL.RESEARCH_PROJECT_SUMMARY')}​`} :{' '}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={12} lg={9}>
                    <Typography variant={'body2'}>{initialData?.researchProjectSummary_th ?? '-'}</Typography>
                </Grid>
            </Grid>
            {/* <Grid container item>
                <Grid item xs={12} md={12} lg={3}>
                    <Typography variant={'body2'}>
                        {`${translate.get('LABEL.RESEARCH_PROJECT_SUMMARY')}​ (${translate.get('LABEL.ENG')}​)`} :{' '}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={12} lg={9}>
                    <Typography variant={'body2'}>{initialData?.researchProjectSummary_en ?? '-'}</Typography>
                </Grid>
            </Grid> */}

            <Grid container item>
                <Grid item xs={12} md={12} lg={3}>
                    <Typography variant={'body2'}>{translate.get('LABEL.ADVISOR_NAME')} : </Typography>
                </Grid>
                <Grid item xs={12} md={12} lg={9}>
                    <Typography variant={'body2'}>{initialData?.projectAdvisor ?? '-'}</Typography>
                </Grid>
            </Grid>
            <Grid container item>
                <Grid item xs={12} md={12} lg={3}>
                    <Typography variant={'body2'}>{translate.get('LABEL.ADVISOR_EMAIL')} : </Typography>
                </Grid>
                <Grid item xs={12} md={12} lg={9}>
                    <Typography variant={'body2'}>{initialData?.projectAdvisorEmail ?? '-'}</Typography>
                </Grid>
            </Grid>
            <Grid container item>
                <Grid item xs={12} md={12} lg={3}>
                    <Typography variant={'body2'}>{translate.get('LABEL.ADVISOR_EMAIL_RESERVE')} : </Typography>
                </Grid>
                <Grid item xs={12} md={12} lg={9}>
                    <Typography variant={'body2'}>{initialData?.projectAdvisorEmailReserve ?? '-'}</Typography>
                </Grid>
            </Grid>
        </Grid>
    )

    return (
        <>
            {hideAccordion ? (
                renderElement()
            ) : (
                <MyAccordion title={translate.get('LABEL.PROJECT_DETAIL')}>{renderElement()}</MyAccordion>
            )}
        </>
    )
}

let ResearchDetailCtrl: React.FC<ResearchDetailCtrlType> = ({ ...props }) => {
    const researchDetailModel = useResearchDetail({ ...props })
    return <ResearchDetailView {...researchDetailModel} {...props} />
}

export default ResearchDetailCtrl
